__turbopack_context__.v({
  "kit-options__disclaimer": "KitOptions-module-scss-module__DyWZHq__kit-options__disclaimer",
});
